import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { VehicleNegotiationInfoUser } from 'src/app/core/interfaces/negotiation/vehicle-negotiation-info-user';
import { CargoService } from 'src/app/core/services/cargo.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { TransportRequestsService } from 'src/app/src/app/core/services/transport-requests.service';
import { CargoDetailService } from '../cargo-detail/cargo-detail.service';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { AssignVehicleCargoComponent } from '../assign-vehicle-cargo/assign-vehicle-cargo.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { VehiclesService } from '../../administration/vehicles/list-vehicles.service';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { DetailVehicleComponent } from '../../administration/vehicles/detail-vehicle/detail-vehicle.component';
import { Destination } from 'src/app/core/interfaces/destination';
import { Utils } from 'src/app/core/resources/utils';
import { CargoStateDict, CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { Permission } from 'src/app/core/resources/permission';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Subscription } from 'rxjs';
import { FormVehicleComponent } from '../../administration/vehicles/form-vehicle/form-vehicle.component';
import { CreateVehicleApplicationDialogComponent } from './create-vehicle-application-dialog/create-vehicle-application-dialog.component';
import { VehicleNegotiationDTO, VehicleNegotiationEditDTO, VehicleNegotiationEnrichmentResult } from 'src/app/core/interfaces/negotiation/vehicle-negotiation';
import { DateManager } from 'src/app/core/managers/date.manager';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { Fingerprint } from 'src/app/core/interfaces/fingerprint';
import { CargoItemService } from '../cargo-item/cargo-item.service';
import { CurrencyPipe } from '@angular/common';
import { DiscountsAndBonusesCargoService } from '../discounts-and-bonuses-cargo/discounts-and-bonuses-cargo.service';
import { DiscountsAndBonuses } from 'src/app/core/interfaces/discountsAndBonuses';
import { AuthService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-vehicle-applications-transport-requests',
  templateUrl: './vehicle-applications-transport-requests.component.html',
  styleUrls: ['./vehicle-applications-transport-requests.component.scss'],
  providers: [TransportRequestsService, CurrencyPipe]
})
export class VehicleApplicationsTransportRequestsComponent implements OnDestroy, OnInit {

  public permission = Permission;
  public applicationTypeFilter: 'Created' | 'Refuse' | 'All' = 'All';
  public sortBy: 'date' | 'companyTrips' = 'date';
  public createdApplications: VehicleNegotiationInfoUser[] = [];
  public refusedApplications: VehicleNegotiationInfoUser[] = [];
  public request: Cargo;
  private isListeningCargoChanges: boolean = false;
  private listenerId: string = '';
  private cargoChangesSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private transportRequestsService: TransportRequestsService,
    private cargoDetailService: CargoDetailService,
    private cargoService: CargoService,
    private snackbarService: SnackBarService,
    private spinner: NgxSpinnerService,
    private matDialog: MatDialog,
    private vehiclesService: VehiclesService,
    public utils: Utils,
    private router: Router,
    private permissionRole: PermissionRole,
    private cargoManager: CargoManager,
    public cargoItemService: CargoItemService,
    public currencyPipe: CurrencyPipe,
    private discountsAndBonusesCargoService: DiscountsAndBonusesCargoService,
    private authService: AuthService,
    private dialog: MatDialog
  ) { }

  async ngOnInit(): Promise<void> {
    const { success } = await this.initialize();
    if (success) this.openCargoListener(this.request.consecutive);
  }

  private async initialize(): Promise<{ success: boolean }> {
    this.spinner.show();
    const { success: successCargo } = await this.getRequest();
    if (!successCargo) {
      this.spinner.hide();
      this.snackbarService.openSnackBar('Ocurrió un error al intentar obtener el detalle del servicio', undefined, 'error');
      this.router.navigate(['/cargo/list/request']);
      return { success: false };
    }
    const { applications: createdApplications } = await this.getVehicleNegotiations(this.request.id, 'Created');
    this.createdApplications = createdApplications;
    const { applications: refusedApplications } = await this.getVehicleNegotiations(this.request.id, 'Refuse');
    this.refusedApplications = refusedApplications;
    this.spinner.hide();
    return { success: true };
  }
  private async getCargo(consecutive: number): Promise<Cargo> {
    try {
      const cargo = await this.cargoDetailService.detailCargoByConsecutive(consecutive.toString()).toPromise();
      if (!cargo || !cargo.id) return null;
      return cargo;
    } catch (error) {
      return null;
    }
  }
  private async getRequest(): Promise<{ success: boolean }> {
    const params = this.route.snapshot.params;
    const cargo = await this.getCargo(params.consecutive);
    if (!cargo || !cargo.id) return { success: false };
    this.request = cargo;
    return { success: true };
  }
  private async getVehicleNegotiations(cargoId: string, state: 'Refuse' | 'Created' = 'Created'): Promise<{ applications: VehicleNegotiationInfoUser[] }> {
    try {
      const response = await this.transportRequestsService.getVehicleNegotiations({ cargoId, state }).toPromise();
      if (!response) return { applications: [] };
      if (!response.results || !response.results.length) return { applications: [] };
      return { applications: this.sortApplications(response.results) };
    } catch (error) {
      console.error(error);
      return { applications: [] };
    }
  }

  private async openCargoListener(consecutive: number): Promise<void> {
    if (!consecutive) return;
    const { active, id, eventEmitter } = await this.cargoService.composeWatchByConsecutive(Number(consecutive));
    this.isListeningCargoChanges = active;
    if (!active) return;
    this.listenerId = id;
    this.cargoChangesSub = eventEmitter.subscribe((cargo: Cargo) => {
      if (!cargo || (cargo && this.request && cargo.id !== this.request.id)) return;
      this.request = cargo;
      this.refreshApplications();
    }, console.error);
  }
  public async refreshApplications(type: 'Created' | 'Refuse' | 'All' = 'All'): Promise<void> {
    this.spinner.show();
    if (type === 'All' || type === 'Created') {
      const { applications: createdApplications } = await this.getVehicleNegotiations(this.request.id, 'Created');
      this.createdApplications = createdApplications;
    }
    if (type === 'All' || type === 'Refuse') {
      const { applications: refusedApplications } = await this.getVehicleNegotiations(this.request.id, 'Refuse');
      this.refusedApplications = refusedApplications;
    }
    this.spinner.hide();
  }

  private sortApplications(applications: VehicleNegotiationInfoUser[]): VehicleNegotiationInfoUser[] {
    if (!applications || !applications.length) return applications || [];
    return [...applications].sort((a: VehicleNegotiationInfoUser, b: VehicleNegotiationInfoUser) => {
      const primary = this.sortBy === 'companyTrips' ? this.compareByCompanyTrips(a, b) : this.compareByDate(a, b);
      if (primary !== 0) return primary;
      return this.sortBy === 'companyTrips' ? this.compareByDate(a, b) : this.compareByCompanyTrips(a, b);
    });
  }
  private compareByDate(a: VehicleNegotiationInfoUser, b: VehicleNegotiationInfoUser): number {
    const fingerprintA = this.utils.getNestedValue(a, 'fingerprint.date');
    const fingerprintB = this.utils.getNestedValue(b, 'fingerprint.date');
    if (!fingerprintA && !fingerprintB) return 0;
    if (!fingerprintA) return 1;
    if (!fingerprintB) return -1;
    const dateA = DateManager.stringToDate(fingerprintA);
    const dateB = DateManager.stringToDate(fingerprintB);
    if (DateManager.isBefore(dateA, dateB, 'seconds')) return -1;
    if (DateManager.isBefore(dateB, dateA, 'seconds')) return 1;
    return 0;
  }
  private compareByCompanyTrips(a: VehicleNegotiationInfoUser, b: VehicleNegotiationInfoUser): number {
    const tripsA = Number(this.utils.getNestedValue(a, 'companyTrips')) || 0;
    const tripsB = Number(this.utils.getNestedValue(b, 'companyTrips')) || 0;
    return tripsB - tripsA;
  }
  public onSortChange(sortBy: 'date' | 'companyTrips'): void {
    this.sortBy = sortBy;
    this.createdApplications = this.sortApplications(this.createdApplications);
    this.refusedApplications = this.sortApplications(this.refusedApplications);
  }
  public onRefreshAllApplications() {
    this.enrichApplications();
  }
  public onRefreshApplication(application: VehicleNegotiationInfoUser) {
    if (!application || !application.id)
      return this.snackbarService.openSnackBar('No es posible actualizar la postulación', undefined, 'error');
    this.enrichApplications([application.id]);
  }
  private async enrichApplications(offerIds?: string[]) {
    if (!this.request || !this.request.id)
      return this.snackbarService.openSnackBar('No es posible obtener el detalle del servicio', undefined, 'error');
    const isIndividual = !!(offerIds && offerIds.length === 1);
    this.spinner.show();
    let shouldRefresh = false;
    try {
      const result = await this.transportRequestsService.enrichVehicleNegotiationOffers(this.request.id, offerIds).toPromise();
      this.showEnrichmentFeedback(this.getEnrichmentFeedback(result, isIndividual));
      shouldRefresh = !!(result && result.updated);
    } catch (error) {
      console.error(error);
      this.snackbarService.openSnackBar(
        isIndividual
          ? 'Ocurrió un error al intentar actualizar la postulación'
          : 'Ocurrió un error al intentar actualizar las postulaciones',
        undefined,
        'error'
      );
    } finally {
      this.spinner.hide();
    }
    if (shouldRefresh) await this.refreshApplications();
  }
  private showEnrichmentFeedback(feedback: { message: string; type: 'success' | 'error' | 'info' | 'alert'; details?: string[] }) {
    if (feedback.details && feedback.details.length) return this.openEnrichmentResultDialog(feedback);
    return this.snackbarService.openSnackBar(feedback.message, undefined, feedback.type);
  }
  private openEnrichmentResultDialog(feedback: { message: string; type: 'success' | 'error' | 'info' | 'alert'; details?: string[] }) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: feedback.message,
      messageList: feedback.details,
      hideBtnConfirm: true,
      icon: feedback.type === 'success',
      iconAlert: feedback.type === 'alert' || feedback.type === 'info',
      iconError: feedback.type === 'error'
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.matDialog.open(DialogComponent, dialogConfig);
  }
  private getEnrichmentFeedback(
    result: VehicleNegotiationEnrichmentResult,
    isIndividual: boolean
  ): { message: string, type: 'success' | 'error' | 'info' | 'alert', details?: string[] } {
    const updated = result && result.updated ? result.updated : 0;
    const skipped = result && result.skipped ? result.skipped : 0;
    const failed = result && result.failed ? result.failed : 0;
    const total = result && result.total ? result.total : 0;

    if (isIndividual) {
      if (updated > 0) return { message: 'La postulación se actualizó correctamente', type: 'success' };
      if (failed > 0) return { message: 'No fue posible actualizar la postulación', type: 'error' };
      return { message: 'La postulación ya está al día', type: 'info' };
    }

    if (!total) return { message: 'No se encontraron postulaciones para actualizar', type: 'alert' };
    if (failed > 0 && updated === 0 && skipped === 0)
      return { message: 'Ocurrió un error al actualizar las postulaciones', type: 'error' };
    if (updated === 0 && skipped > 0 && failed === 0)
      return { message: 'Las postulaciones ya están al día', type: 'info' };
    if (updated > 0 && skipped === 0 && failed === 0)
      return { message: 'Las postulaciones se actualizaron correctamente', type: 'success' };
    let type: 'success' | 'error' | 'info' | 'alert' = 'alert';
    if (failed === 0 && updated > 0) type = 'success';

    return {
      message: 'Resultado de la actualización',
      type,
      details: [
        'Total: ' + total,
        'Actualizadas: ' + updated,
        'Ya estaban al día: ' + skipped,
        'Con error: ' + failed
      ]
    };
  }

  public get hasAvailableActions(): { available: boolean, reason?: string } {
    if (!this.request) return { available: false, reason: 'No es posible obtener el detalle del servicio' };
    if (this.request.assignedDriver && this.request.licensePlate)
      return { available: false, reason: `El servicio ya fue asignado al vehículo ${this.request.licensePlate}` };
    if (![CargoStateEnum.CREATED, CargoStateEnum.REQUEST, CargoStateEnum.ACCEPTED].includes(this.request.state))
      return { available: false, reason: `El servicio no está en un estado válido` };
    return { available: true };
  }
  public get hasBasicPermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.assignLicensePlate);
  }
  public get hasSpecialPermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.specialLicensePlate);
  }
  public get hasCreationPermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.createApplications);
  }
  public get hasEditPermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.editApplications);
  }
  public get hasApproveBonusFromApplicationPermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.approveBonusFromApplication);
  }
  public get showCreatedApplications(): boolean {
    return this.applicationTypeFilter === 'All' || this.applicationTypeFilter === 'Created';
  }
  public get showRefusedApplications(): boolean {
    if (this.applicationTypeFilter === 'Refuse') return true;
    if (this.applicationTypeFilter === 'All') return !!(this.refusedApplications && this.refusedApplications.length);
    return false;
  }
  public isDisabledAssign(application: VehicleNegotiationInfoUser, index: number): { isDisabled: boolean, reason?: string } {
    if (!this.hasAvailableActions.available) return { isDisabled: true, reason: this.hasAvailableActions.reason };
    if (application && application.licensePlate === 'C0N111' && !this.hasSpecialPermission)
      return { isDisabled: true, reason: 'No tienes permisos para asignar el vehículo C0N111' };
    else if (!this.hasBasicPermission) return { isDisabled: true, reason: 'No tienes permisos para asignar postulaciones' };
    if (index) return { isDisabled: true, reason: 'Solo es posible asignar la primera postulación, debe rechazar la primera postulación para poder asignar las siguientes' };
    if (!application.finalValue) return { isDisabled: true, reason: 'Debe tener una oferta para poder asignar' };
    if (this.request.state === CargoStateEnum.REQUEST) return { isDisabled: true, reason: 'El servicio está en estado de solicitud, debes terminar la solicitud para poder asignar' };
    return { isDisabled: false };
  }
  public async onAccepted(negotiation: VehicleNegotiationInfoUser): Promise<void> {
    const vehicle = await this.getVehicle(negotiation.licensePlate);
    if (!vehicle) {
      const { confirm } = await this.openDialogConfirm(`El vehículo ${negotiation.licensePlate} no existe, ¿desea crearlo?`);
      if (confirm) this.openDialogCreateVehicle(negotiation);
      else this.snackbarService.openSnackBar(`No es posible asignar la postulación de un vehículo inexistente`, undefined, 'error');
      return;
    }
    const cargoFreightCost = this.cargoItemService.getRealCost(this.request);
    const negotiationFreightCost = this.getOffer(negotiation).offer;
    if (negotiationFreightCost !== cargoFreightCost) {
      const requiresBonus = negotiationFreightCost > cargoFreightCost;
      if (requiresBonus && !this.hasApproveBonusFromApplicationPermission)
        return this.cargoManager.openDialogError(
          "No es posible asignar esta postulación",
          null,
          `<div class="text-center">Esta postulación tiene un flete superior al del servicio, para asignarlo se requiere el permiso <b class="text-bold">"Asignar postulaciones sin restricción"</b></div>`
        );
      const { confirm } = await this.cargoManager.openDialogConfirm(
        'La oferta del conductor es diferente al flete del servicio',
        `La oferta del conductor (${this.currencyPipe.transform(negotiationFreightCost, 'COP', 'code')}) 
        es diferente al flete del servicio (${this.currencyPipe.transform(cargoFreightCost, 'COP', 'code')}), si continúa, se asignará el vehículo con un 
        ${requiresBonus ? 'bono' : 'descuento'} automático. ¿Desea continuar?`
      );
      if (!confirm) return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: "Datos del Vehículo Asignado",
      cargo: this.request,
      type: 'assign',
      licensePlate: negotiation.licensePlate
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const result = await this.matDialog.open(AssignVehicleCargoComponent, dialogConfig).afterClosed().toPromise();
    if (!result || !result.state) return;
    this.isListeningCargoChanges ? this.refreshApplications() : this.initialize();
    if (negotiationFreightCost !== cargoFreightCost) {
      const discountOrBonus = negotiationFreightCost > cargoFreightCost ? 'bonus' : 'discount';
      const { success, error } = await this.createDiscountOrBonus(negotiationFreightCost, cargoFreightCost, discountOrBonus);
      if (!success) return this.snackbarService.openSnackBar(error, undefined, 'error');
    }
    this.snackbarService.openSnackBar(`El conductor de ID ${negotiation.applicantId} y placa ${negotiation.licensePlate} ha sido correctamente asignado`);
  }
  private async openDialogCreateVehicle(negotiation: VehicleNegotiationInfoUser) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      company: {
        exclusive: this.request.exclusive,
        nit: this.request.idCompany
      },
      cargoId: this.request.id
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const result = await this.matDialog.open(FormVehicleComponent, dialogConfig).afterClosed().toPromise();
    const resultVehicleId = this.utils.getNestedValue(result, 'value.vehicle.id');
    if (result && result.state && resultVehicleId === negotiation.licensePlate)
      this.onAccepted(negotiation);
  }
  private async createDiscountOrBonus(negotiationFreightCost: number, cargoFreightCost: number, discountOrBonus: 'discount' | 'bonus'): Promise<{ success: boolean, error?: string }> {
    try {
      const type = discountOrBonus === 'bonus' ? 0 : 1;
      const catalogTypeModification = await this.discountsAndBonusesCargoService.getListTypeModification(type).toPromise() as { id: string, name: string, type: string }[];
      if (!catalogTypeModification || !catalogTypeModification.length)
        return { success: false, error: `Ocurrió un error al intentar crear el ${discountOrBonus === 'bonus' ? 'bono' : 'descuento'} automático` };
      const typeModification = catalogTypeModification.find(typeModification => typeModification.name === "Ajuste por asignación de vehículo");
      if (!typeModification) return { success: false, error: `Ocurrió un error al intentar crear el ${discountOrBonus === 'bonus' ? 'bono' : 'descuento'} automático` };
      const difference = discountOrBonus === 'bonus' ? negotiationFreightCost - cargoFreightCost : cargoFreightCost - negotiationFreightCost;
      const discountOrBonusData: DiscountsAndBonuses = {
        cargoId: this.request.id,
        type: type,
        amount: difference,
        amountRate: 0,
        userId: this.authService.getUserSession() ? this.authService.getUserSession().information.document : '',
        userName: this.authService.getUserSession() ? this.authService.getUserSession().information.name : '',
        observation: `${discountOrBonus === 'bonus' ? 'Bonificación' : 'Descuento'} automático por la asignación del vehículo`,
        typeModification: typeModification
      };
      await this.discountsAndBonusesCargoService.shippingCostModify(discountOrBonusData).toPromise();
      return { success: true };
    } catch (error) {
      console.error(error);
      return { success: false, error: `Ocurrió un error al intentar crear el ${discountOrBonus === 'bonus' ? 'bono' : 'descuento'} automático` };
    }
  }

  public isDisabledRefuse(negotiation: VehicleNegotiationInfoUser): { isDisabled: boolean, reason?: string } {
    if (!this.hasAvailableActions.available) return { isDisabled: true, reason: this.hasAvailableActions.reason };
    if (negotiation && negotiation.licensePlate === 'C0N111' && !this.hasSpecialPermission)
      return { isDisabled: true, reason: 'No tienes permisos para rechazar el vehículo C0N111' };
    else if (!this.hasBasicPermission) return { isDisabled: true, reason: 'No tienes permisos para rechazar postulaciones' };
    return { isDisabled: false };
  }
  private async requestRefuseReason(negotiation: VehicleNegotiationInfoUser): Promise<{ confirm: boolean, description?: string }> {
    const refuseReasons = [
      "Vehículo no apto por seguridad",
      "Vehículo no cumple requisitos del cliente",
      "Documentación incompleta o vencida",
      "Vehículo no cumple condiciones de presentación",
      "Vehículo no cumple requisitos de seguridad del cliente",
      "Vehículo no disponible para la operación",
      "Vehículo con restricciones operativas",
      "Antecedentes de incumplimiento",
      "Vehículo no cumple condiciones técnicas de la carga",
      "Flete no aceptado"
    ];
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `¿Está seguro que desea rechazar la postulación del conductor de ID ${negotiation.applicantId} y placa ${negotiation.licensePlate}?`,
      viewSelect: true,
      listLabel: "Seleccione un motivo de rechazo",
      list: refuseReasons.map((reason: string) => ({ value: reason, key: reason })),
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    const result = await this.dialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    if (!result || !result.state) return { confirm: false, description: null };
    return { confirm: true, description: result.itemSelected };
  }
  public async onRefuse(negotiation: VehicleNegotiationInfoUser): Promise<void> {
    const { confirm, description } = await this.requestRefuseReason(negotiation);
    if (!confirm) return;
    this.spinner.show();
    try {
      await this.transportRequestsService.negotiationsVehiclesOffers(negotiation.id, 'Refuse', description).toPromise();
      this.spinner.hide();
      this.isListeningCargoChanges ? this.refreshApplications() : this.initialize();
      this.snackbarService.openSnackBar(`La postulación ha sido rechazada correctamente`);
    } catch (error) {
      console.error(error);
      this.spinner.hide();
      this.snackbarService.openSnackBar(`Ocurrió un error al intentar rechazar la postulación`, undefined, 'error');
    }
  }
  public isDisabledRefuseAll(applicationsList: VehicleNegotiationInfoUser[]): { isDisabled: boolean, reason?: string } {
    if (!applicationsList || !applicationsList.length) return { isDisabled: true, reason: 'No hay postulaciones abiertas para rechazar' };
    const hasDisabledApplication = applicationsList.some((application: VehicleNegotiationInfoUser) =>
      this.isDisabledRefuse(application).isDisabled
    );
    if (hasDisabledApplication) return { isDisabled: true, reason: 'Debe estar habilitado el rechazo para todas las postulaciones' };
    return { isDisabled: false };
  }
  public async onRefuseAll(applicationsList: VehicleNegotiationInfoUser[]): Promise<void> {
    const refuseAllValidation = this.isDisabledRefuseAll(applicationsList);
    if (refuseAllValidation.isDisabled)
      return this.snackbarService.openSnackBar(refuseAllValidation.reason, undefined, 'error');
    const { confirm, description } = await this.cargoManager.openDialogConfirmWithDescription(
      `¿Está seguro que desea rechazar todas las postulaciones?`,
      'Motivo de rechazo'
    );
    if (!confirm) return;
    this.spinner.show();
    try {
      await Promise.all(
        applicationsList.map((application: VehicleNegotiationInfoUser) =>
          this.transportRequestsService.negotiationsVehiclesOffers(application.id, 'Refuse', description).toPromise()
        )
      );
      this.spinner.hide();
      this.isListeningCargoChanges ? this.refreshApplications() : this.initialize();
      this.snackbarService.openSnackBar(`Las postulaciones han sido rechazadas correctamente`);
    } catch (error) {
      console.error(error);
      this.spinner.hide();
      this.isListeningCargoChanges ? this.refreshApplications() : this.initialize();
      this.snackbarService.openSnackBar(`Ocurrió un error al intentar rechazar todas las postulaciones`, undefined, 'error');
    }
  }

  public isDisabledRestore(negotiation: VehicleNegotiationInfoUser): { isDisabled: boolean, reason?: string } {
    if (!this.hasAvailableActions.available) return { isDisabled: true, reason: this.hasAvailableActions.reason };
    if (negotiation && negotiation.licensePlate === 'C0N111' && !this.hasSpecialPermission)
      return { isDisabled: true, reason: 'No tienes permisos para restaurar el vehículo C0N111' };
    else if (!this.hasBasicPermission) return { isDisabled: true, reason: 'No tienes permisos para restaurar postulaciones' };
    return { isDisabled: false };
  }
  public async onRestore(negotiation: VehicleNegotiationInfoUser): Promise<void> {
    const { confirm } = await this.openDialogConfirm(`¿Está seguro que desea restaurar la postulación del conductor de ID ${negotiation.applicantId} y placa ${negotiation.licensePlate}?`);
    if (!confirm) return;
    this.spinner.show();
    try {
      await this.transportRequestsService.negotiationsVehiclesOffers(negotiation.id, 'Created').toPromise();
      this.spinner.hide();
      this.isListeningCargoChanges ? this.refreshApplications() : this.initialize();
      this.snackbarService.openSnackBar(`La postulación ha sido restaurada correctamente`);
    } catch (error) {
      console.error(error);
      this.spinner.hide();
      this.snackbarService.openSnackBar(`Ocurrió un error al intentar restaurar la postulación`, undefined, 'error');
    }
  }

  public isDisabledCreateApplication(): { isDisabled: boolean, reason?: string } {
    if (!this.hasAvailableActions.available) return { isDisabled: true, reason: this.hasAvailableActions.reason };
    if (!this.hasCreationPermission) return { isDisabled: true, reason: 'No tienes permisos para crear postulaciones' };
    return { isDisabled: false };
  }
  public async onCreateApplication() {
    const result: { state: boolean, negotiation?: VehicleNegotiationDTO } = await this.openModalApplication('create');
    if (!result.state || !result.negotiation) return;
    if (result.negotiation.offer) delete result.negotiation.offer;
    this.spinner.show();
    try {
      await this.transportRequestsService.createVehicleNegotiation({ ...result.negotiation, cargoId: this.request.id }).toPromise();
      this.snackbarService.openSnackBar('La postulación fue creada correctamente', undefined, 'success');
      this.isListeningCargoChanges ? this.refreshApplications('Created') : this.initialize();
    } catch (error) {
      console.error(error);
      this.snackbarService.openSnackBar('Ocurrió un error al intentar crear la postulación', undefined, 'error');
    } finally {
      this.spinner.hide();
    }
  }

  public isDisabledEditApplication(): { isDisabled: boolean, reason?: string } {
    if (!this.hasAvailableActions.available) return { isDisabled: true, reason: this.hasAvailableActions.reason };
    if (!this.hasEditPermission) return { isDisabled: true, reason: 'No tienes permisos para editar postulaciones' };
    return { isDisabled: false };
  }
  public async onEditApplication(negotiation: VehicleNegotiationInfoUser) {
    const result: { state: boolean, negotiation?: VehicleNegotiationEditDTO } = await this.openModalApplication('edit', negotiation);
    if (!result.state || !result.negotiation) return;
    if (result.negotiation.offer) result.negotiation['finalValue'] = result.negotiation.offer;
    this.spinner.show();
    try {
      await this.transportRequestsService.editVehicleNegotiation(result.negotiation, negotiation.id).toPromise();
      this.snackbarService.openSnackBar('La postulación fue editada correctamente', undefined, 'success');
      this.isListeningCargoChanges ? this.refreshApplications('Created') : this.initialize();
    } catch (error) {
      console.error(error);
      this.snackbarService.openSnackBar('Ocurrió un error al intentar editar la postulación', undefined, 'error');
    } finally {
      this.spinner.hide();
    }
  }

  private async openModalApplication(mode: 'create' | 'edit', negotiation?: VehicleNegotiationInfoUser): Promise<{ state: boolean, negotiation?: VehicleNegotiationDTO }> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      mode,
      applicationList: [...this.createdApplications, ...this.refusedApplications]
    };
    if (mode === 'edit' && negotiation) dialogConfig.data['negotiation'] = negotiation;
    const initialVehicleType = this.utils.getNestedValue(this.request, 'cargoFeature.vehicleType.name');
    const initialBodyWorkType = this.utils.getNestedValue(this.request, 'cargoFeature.vehicleType.bodyWorkType.name');
    if (mode === 'create' && (initialVehicleType || initialBodyWorkType)) {
      dialogConfig.data['initialVehicleType'] = initialVehicleType;
      dialogConfig.data['initialBodyWorkType'] = initialBodyWorkType;
    }
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const result = await this.matDialog.open(CreateVehicleApplicationDialogComponent, dialogConfig).afterClosed().toPromise();
    if (!result || !result.state || !result.negotiation) return { state: false, negotiation: null };
    return { state: true, negotiation: result.negotiation };
  }

  private async getVehicle(licensePlate: string): Promise<Vehicle> {
    let vehicle: Vehicle;
    this.spinner.show();
    try { vehicle = await this.vehiclesService.getVehicleFromOwnCompany(licensePlate).toPromise(); } catch (error) { }
    this.spinner.hide();
    return vehicle && vehicle.id ? vehicle : null;
  }
  public async getDetailVehicle(negotiation: VehicleNegotiationInfoUser) {
    if (!negotiation || !negotiation.licensePlate) return;
    let vehicle = await this.getVehicle(negotiation.licensePlate);
    if (!vehicle) return this.snackbarService.openSnackBar("El vehículo no se encuentra registrado en el sistema	", undefined, "error");
    this.openDetailVehicle(vehicle);
  }
  private openDetailVehicle(vehicle: Vehicle): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicle: vehicle,
      close: true,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    this.matDialog.open(DetailVehicleComponent, dialogConfig);
  }

  private async openDialogConfirm(title: string, description?: string): Promise<{ confirm: boolean }> {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title,
      iconAlert: true,
      labelButton1: 'Cancelar',
      labelButton2: 'Continuar',
      hideBtnCancel: true,
      hideBtnConfirm: true,
    };
    if (description) dialogConfig.data.descriptionHTML = `<div class="text-center text-bold">${description}</div>`;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialog = this.matDialog.open(DialogComponent, dialogConfig);
    const result = await dialog.afterClosed().toPromise();
    if (!result || !result.state || !result.refuse || result.refuse === "Cancelar") return { confirm: false };
    return { confirm: true };
  }
  public getVehicleType(negotiation: VehicleNegotiationInfoUser): { vehicleType: string, isDifferent?: boolean } {
    const negotiationVehicleType: string = this.utils.getNestedValue(negotiation, 'vehicleType');
    const cargoVehicleType: string = this.utils.getNestedValue(this.request, 'cargoFeature.vehicleType.name');
    if (!negotiationVehicleType)
      return { vehicleType: '-', isDifferent: false };
    if (!cargoVehicleType) return { vehicleType: negotiationVehicleType, isDifferent: false };
    return { vehicleType: negotiationVehicleType, isDifferent: negotiationVehicleType !== cargoVehicleType };
  }
  public getBodyWorkType(negotiation: VehicleNegotiationInfoUser): { bodyWorkType: string, isDifferent?: boolean } {
    const negotiationBodyWorkType: string = this.utils.getNestedValue(negotiation, 'bodyWorkType');
    const cargoBodyWorkType: string = this.utils.getNestedValue(this.request, 'cargoFeature.vehicleType.bodyWorkType.name');
    if (!negotiationBodyWorkType)
      return { bodyWorkType: '-', isDifferent: false };
    if (!cargoBodyWorkType) return { bodyWorkType: negotiationBodyWorkType, isDifferent: false };
    return { bodyWorkType: negotiationBodyWorkType, isDifferent: negotiationBodyWorkType !== cargoBodyWorkType };
  }
  public getLoadCapacity(negotiation: VehicleNegotiationInfoUser): { loadCapacity: string, isLess?: boolean } {
    const negotiationLoadCapacity: number = this.utils.getNestedValue(negotiation, 'loadCapacity');
    const cargoLoadCapacity: number = this.utils.getNestedValue(this.request, 'cargoFeature.cargoMeasure.totalWeigth');
    if (!negotiationLoadCapacity)
      return { loadCapacity: '-', isLess: false };
    if (!cargoLoadCapacity) return { loadCapacity: `${negotiationLoadCapacity} kg`, isLess: false };
    return { loadCapacity: `${negotiationLoadCapacity} kg`, isLess: negotiationLoadCapacity < cargoLoadCapacity };
  }
  public getOffer(negotiation: VehicleNegotiationInfoUser): { offer: number, isMore?: boolean } {
    const negotiationOffer: number = this.utils.getNestedValue(negotiation, 'offer');
    const negotiationFinalValue: number = this.utils.getNestedValue(negotiation, 'finalValue');
    const negotiationInitialValue: number = this.utils.getNestedValue(negotiation, 'initialValue');
    const negotiationRealOffer = negotiationFinalValue
      ? negotiationFinalValue
      : negotiationInitialValue
        ? negotiationInitialValue
        : negotiationOffer
          ? negotiationOffer
          : null;
    const cargoOffer: number = this.cargoItemService.getRealCost(this.request);
    if (!negotiationRealOffer)
      return { offer: 0, isMore: false };
    if (!cargoOffer) return { offer: negotiationRealOffer, isMore: false };
    return { offer: negotiationRealOffer, isMore: negotiationRealOffer > cargoOffer };
  }
  public getCompanyTrips(negotiation: VehicleNegotiationInfoUser): { companyTrips: number, isDifferent: boolean } {
    const companyTrips: number = Number(this.utils.getNestedValue(negotiation, 'companyTrips')) || 0;
    const negotiationCompanyId: string = this.utils.getNestedValue(negotiation, 'companyId');
    const cargoCompanyId: string = this.utils.getNestedValue(this.request, 'idCompany');
    const isDifferent: boolean = !!negotiationCompanyId && !!cargoCompanyId && negotiationCompanyId !== cargoCompanyId;
    return { companyTrips, isDifferent };
  }
  public getRefuseReason(negotiation: VehicleNegotiationInfoUser): { completeReason: string, shortReason: string } {
    const negotiationRefuseReason: string = this.utils.getNestedValue(negotiation, 'fingerprintRefuse.observation');
    const negotiationRefuseFingerprint: Fingerprint = this.utils.getNestedValue(negotiation, 'fingerprintRefuse.fingerPrint');
    if (!negotiationRefuseFingerprint || !negotiationRefuseReason)
      return { completeReason: '', shortReason: '-' };
    const shortReason = negotiationRefuseReason.length > 100 ? `${negotiationRefuseReason.substring(0, 100)}...` : negotiationRefuseReason;
    const date = negotiationRefuseFingerprint.date ? DateManager.formatDate(negotiationRefuseFingerprint.date, 'YYYY-MM-DD HH:mm ZZ', 'DD/MM/YYYY HH:mm') : '-';
    const completeReason = `Motivo de rechazo: ${negotiationRefuseReason} - Rechazado por: ${negotiationRefuseFingerprint.userName} (${negotiationRefuseFingerprint.userId}) - Fecha: ${date}`;
    return { completeReason, shortReason };
  }

  get lastDestination(): Destination {
    const destinations: Destination[] = this.utils.getNestedValue(this.request, 'cargoFeature.uploadDownload.destination');
    if (!destinations || !destinations.length) return null;
    return destinations[destinations.length - 1];
  }

  get cargoState(): string {
    if (!this.request) return '';
    return CargoStateDict[this.request.state ? this.request.state : this.request.requestState ? this.request.requestState : ''];
  }

  public tableColumns(sectionType: 'created' | 'closed', applicationList: VehicleNegotiationInfoUser[]): string[] {
    const columns = ['date', 'licensePlate', 'vehicleType', 'bodyWorkType', 'applicantId', 'phone', 'loadCapacity', 'freight', 'companyTrips'];
    if (applicationList && applicationList.length && applicationList.some(application => !!application.numberOfTripsApp))
      columns.push('numberOfTripsApp');
    if (applicationList && applicationList.length && applicationList.some(application => !!application.numberOfTripsRNDC))
      columns.push('numberOfTripsRNDC');
    if (applicationList && applicationList.length && applicationList.some(application => !!application.applicantScore))
      columns.push('applicantScore');
    if (sectionType === 'closed') columns.push('refuseReason');
    columns.push('actions');
    return columns;
  }

  public goBack(): void {
    const path = this.utils.getCargoPathByState(this.request);
    this.router.navigate([path.shortPath]);
  }

  ngOnDestroy(): void {
    if (this.cargoChangesSub) this.cargoChangesSub.unsubscribe();
    if (this.listenerId) this.cargoService.stopWatch(this.listenerId);
  }
}
